import './css/styles.scss';

let isScrolling: number;

function throttle(func: () => void, limit: number) {
	let inThrottle: boolean;
	return function () {
		if (!inThrottle) {
			func();
			inThrottle = true;
			setTimeout(() => (inThrottle = false), limit);
		}
	};
}
function initStickyHeader() {
	const header = document.querySelector('header.wp-block-template-part') as HTMLElement;
	if (!header) return;

	let headerOffset = header.offsetHeight;

	const adminBar = document.querySelector('#wpadminbar') as HTMLElement;
	if (adminBar) {
		headerOffset += adminBar.offsetHeight;
	}
	console.log('initStickyHeader');
	console.log(headerOffset);

	let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

	const windowScroll = window.scrollY || window.pageYOffset;

	const threshold = 4; // Adjust this value to your needs

	if (currentScroll >= threshold) {
		header.classList.add('fixed-header');
	} else {
		header.classList.remove('fixed-header');
	}
}

const throttledInitStickyHeader = throttle(initStickyHeader, 25);

window.addEventListener('load', function () {
	throttledInitStickyHeader();
	window.addEventListener('resize', throttledInitStickyHeader);
	window.addEventListener('scroll', function () {
		// Clear our timeout throughout the scroll
		window.clearTimeout(isScrolling);

		// Set a timeout to run after scrolling ends
		isScrolling = setTimeout(function () {
			// Run the callback
			initStickyHeader();
		}, 66);

		// Call the throttled function for while scrolling
		throttledInitStickyHeader();
	});
});

// when dom is ready
